import { render, staticRenderFns } from "./TopTravelList.vue?vue&type=template&id=0c38be83&scoped=true&"
import script from "./TopTravelList.vue?vue&type=script&lang=js&"
export * from "./TopTravelList.vue?vue&type=script&lang=js&"
import style0 from "./TopTravelList.vue?vue&type=style&index=0&id=0c38be83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38be83",
  null
  
)

export default component.exports